/**
 * Yield Forecast API-Funktionen (Ertragsprognosen)
 * CRUD-Operationen für Ertragsprognosen und Abzugspositionen (DeductionItems)
 */
import { api } from './client';
import { Ertragsprognose, DeductionItem, DeductionItemCreate, DeductionItemUpdate } from '../../types';

export const yieldForecastsApi = {
  async getProjectErtragsprognosen(projectId: string): Promise<any[]> {
    return api.get(`/projects/${projectId}/yield-forecasts`);
  },

  /**
   * Holt die aggregierte aktive Ertragsprognose eines Projekts.
   * Bei mehreren aktiven Prognosen werden Durchschnittswerte berechnet.
   * Gibt null zurück wenn keine aktive Prognose vorhanden.
   */
  async getActiveProjectErtragsprognose(projectId: string): Promise<Ertragsprognose | null> {
    return api.get(`/projects/${projectId}/active-yield-forecast`);
  },

  async getYieldForecast(projectId: string, yieldForecastId: string): Promise<Ertragsprognose> {
    return api.get(`/projects/${projectId}/yield-forecasts/${yieldForecastId}`);
  },

  async createProjectErtragsprognose(
    projectId: string,
    ertragsprognose: Partial<Ertragsprognose>
  ): Promise<Ertragsprognose> {
    return api.post(`/projects/${projectId}/yield-forecasts`, ertragsprognose);
  },

  async updateYieldForecast(
    projectId: string,
    yieldForecastId: string,
    ertragsprognose: Partial<Ertragsprognose>
  ): Promise<Ertragsprognose> {
    return api.put(`/projects/${projectId}/yield-forecasts/${yieldForecastId}`, ertragsprognose);
  },

  async deleteYieldForecast(projectId: string, yieldForecastId: string): Promise<any> {
    return api.delete(`/projects/${projectId}/yield-forecasts/${yieldForecastId}`);
  },

  // DeductionItem (Abzugspositionen) API-Methoden

  async createDeductionItem(
    projectId: string,
    yieldForecastId: string,
    data: DeductionItemCreate
  ): Promise<DeductionItem> {
    return api.post(`/projects/${projectId}/yield-forecasts/${yieldForecastId}/deductions`, data);
  },

  async updateDeductionItem(
    projectId: string,
    yieldForecastId: string,
    itemId: string,
    data: DeductionItemUpdate
  ): Promise<DeductionItem> {
    return api.put(
      `/projects/${projectId}/yield-forecasts/${yieldForecastId}/deductions/${itemId}`,
      data
    );
  },

  async deleteDeductionItem(
    projectId: string,
    yieldForecastId: string,
    itemId: string
  ): Promise<void> {
    return api.delete(
      `/projects/${projectId}/yield-forecasts/${yieldForecastId}/deductions/${itemId}`
    );
  },
};

